var map = {
	"./activity.svg": "kmwz",
	"./bell.svg": "PTkI",
	"./books.svg": "uC/i",
	"./camera-round.svg": "rywh",
	"./camera.svg": "Uj+M",
	"./campus.svg": "Hr4e",
	"./campus_activities.svg": "lRE3",
	"./campus_express.svg": "bEQI",
	"./cap.svg": "/Eyu",
	"./circle.svg": "9wJi",
	"./cloud.svg": "qau1",
	"./contact.svg": "mZNm",
	"./crown.svg": "KDA8",
	"./deleteIcon.svg": "0z6L",
	"./earth.svg": "bHif",
	"./educational.svg": "YDTY",
	"./files.svg": "RdOM",
	"./fire_control.svg": "FDKK",
	"./flag.svg": "uVjb",
	"./gift.svg": "mOTw",
	"./good_news.svg": "yxlY",
	"./headmaster_message.svg": "yH05",
	"./home.svg": "ZTDb",
	"./honor.svg": "crfx",
	"./infor.svg": "MSED",
	"./journalism.svg": "S81j",
	"./mailbox.svg": "GxXn",
	"./medal.svg": "KeHn",
	"./menu.svg": "rVZ4",
	"./microphone.svg": "1OY6",
	"./other.svg": "Bpj3",
	"./party_building.svg": "8Tfx",
	"./pencil.svg": "TcoZ",
	"./people.svg": "Kwzk",
	"./phone.svg": "q9A4",
	"./pic.svg": "Ec/A",
	"./pinglun.svg": "Y6BV",
	"./play.svg": "3MqS",
	"./point.svg": "1R/E",
	"./present.svg": "1L49",
	"./read.svg": "UjW5",
	"./safe_campus.svg": "a5ne",
	"./school_profile.svg": "VAC4",
	"./search-o.svg": "dzwI",
	"./search.svg": "1ny0",
	"./search_new.svg": "IILd",
	"./shelf.svg": "DkO/",
	"./sound.svg": "K5YR",
	"./star.svg": "Lwba",
	"./student_demeanor.svg": "OfUL",
	"./study.svg": "v3pU",
	"./teacher_demeanor.svg": "Wp1x",
	"./team-three.svg": "8k43",
	"./team-two.svg": "rkyj",
	"./telephone.svg": "MqU2",
	"./television.svg": "TSZ4",
	"./tianjia.svg": "GQLr",
	"./time.svg": "dv8Y",
	"./trophy.svg": "HrN6",
	"./video.svg": "LYud"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rdfR";